export default __webpack_public_path__ + "static/media/salary.a5dfbca9.png";